import { Loading, View } from '@acin/ui-core';
import styled from 'styled-components';

export const ObligationRules = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: ${(p) => p.theme.spacing.getSize(4)};
  box-sizing: border-box;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(3)};
  padding-top: ${(p) => p.theme.spacing.getSize(4)};
`;

export const RuleItem = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(3)};
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.borderRadius};
  line-height: 1.5;
  word-break: break-word;
  white-space: normal;
  font-size: ${(p) => p.theme.type.getSize(2)};
`;

export const Sentinel = styled.div`
  height: ${(p) => p.theme.spacing.getSize(5)};
  visibility: hidden;
`;

export const LoadingIndicator = styled(Loading)`
  display: block;
  margin: ${(p) => p.theme.spacing.getSize(3)} 0;
`;

export const InputSection = styled.div`
  padding-top: ${(p) => p.theme.spacing.getSize(4)};
`;

export const RuleTextarea = styled.textarea`
  width: 100%;
  padding: ${(p) => p.theme.spacing.getSize(2)};
  border: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  border-radius: ${(p) => p.theme.spacing.borderRadius};
  font-size: ${(p) => p.theme.type.getSize(0)};
  font-family: inherit;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: ${(p) => p.theme.colors.primary.getValue(500).main};
    box-shadow: 0 0 0 2px ${(p) => p.theme.colors.primary.getValue(500).main}33;
  }
`;
